<template>
    <div class="bagsh">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="title">Багш хүний нөөц</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <div class="left_chart">
                          <div class="left_chart_title">Үндсэн багш</div>
                          <v-chart v-if="vndsenBagsh" :options="vndsenBagsh" style="width: 100%; height: 300px"/>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="right_chart">
                        <div class="right_chart_title">Багшлах эрхийн зэрэг</div>
                        <v-chart v-if="bagshlah_erhiin_zereg" :options="bagshlah_erhiin_zereg" style="width: 100%; height: 300px"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <div class="left_chart">
                        <div class="left_chart_title">Мэргэжлийн боловсрол, сургалтын салбарт ажиллагсад</div>
                        <v-chart v-if="ajillagsad" :options="ajillagsad" style="width: 100%; height: 300px "/>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="right_chart">
                        <div class="right_chart_title">Албан тушаалын төрлөөр</div>
                        <v-chart v-if="alban_tushaal_turul" :options="alban_tushaal_turul" style="width: 100%; height: 300px"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getBagshlahErhiinZereg} from "../api/index"
    export default {
        computed: {

            vndsenBagsh(){
                if(this.undsenbagsh.length >= 1){
                    return {
                        color: ['#9E1A3C','#1054b1'],
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            data: ['Ерөнхий эрдмийн', 'Мэргэжлийн']
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: this.undsenbagsh.map(undsenbagsh=>undsenbagsh.on_sar)
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                name: 'Ерөнхий эрдмийн',
                                type: 'line',
                                data: this.undsenbagsh.map(undsenbagsh=>undsenbagsh.yronhii_erdem)
                            },
                            {
                                name: 'Мэргэжлийн',
                                type: 'line',
                                data: this.undsenbagsh.map(undsenbagsh=>undsenbagsh.mergejil)
                            },

                        ]
                    }
                } else {
                    return null
                }

            },
            ajillagsad(){
                return {
                    color: ['#9E1A3C','#1054b1'],
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['Ажиллагсад', 'Багш нар']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.meregjilss.map(meregjils=>meregjils.on_sar)
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: 'Ажиллагсад',
                            type: 'line',

                            data: this.meregjilss.map(meregjils=>meregjils.ajilagsad)
                        },
                        {
                            name: 'Багш нар',
                            type: 'line',

                            data: this.meregjilss.map(meregjils=>meregjils.bagsh)
                        },

                    ]
                }
            },
            bagshlah_erhiin_zereg(){
                if(this.bagsherhzereg.length >= 1){
                    return {
                        color: ['#c52049', '#9E1A3C','#1054b1','#FF9652',],
                        tooltip: {
                            trigger: 'item',
                            formatter: '{a} <br/>{b} : {c} ({d}%)'
                        },
                        legend: {
                            orient: 'vertical',
                            left: 'left',
                            bottom: 0,
                            //data: ['Ахлах багш', 'Багш', 'Дадлагажигч багш','Мастер багш']
                            data: this.bagsherhzereg.map(row=>{
                                return {
                                    name:row.name
                                }
                            }),
                        },
                        series: [
                            {
                                name: 'Багшлах эрхийн зэрэг',
                                type: 'pie',
                                radius: '50%',
                                center: ['50%', '35%'],
                                data: this.bagsherhzereg.map(row=>{
                                    return {
                                        value:row.too,
                                        name:row.name
                                    }
                                }),
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    }
                } else {
                    return null
                }

            },
            alban_tushaal_turul(){
                if(this.albantushaal.length >= 1){
                    return {
                        //color: ['#c52049', '#9E1A3C','#1054b1','#FF9652','#D00000'],
                        color: ['#4F000B', '#9E1A3C','#CE4257','#FF7F51','#FF9B54'],

                        tooltip: {
                            trigger: 'item',
                            formatter: '{a} <br/>{b} : {c} ({d}%)'
                        },
                        // legend: {
                        //     orient: 'vertical',
                        //     left: 'center',
                        //     bottom: 10,
                        //     data: ['Захирал', 'Дэд захирал', 'Сургалтын албаны дарга','Дотоод, хяналт, чанарын үнэлгээ хариуцсан ажилтан',
                        //         'Нийгмийн түншлэл хариуцсан ажилтан','Хөдөлмөрийн аюулгүй байдал эрүүл ахуй хариуцсан ажилтан',
                        //         'Нийгмийн ажилтан','Номын сангийн ажилтан', 'Нягтлан бодогч','Нярав','Эмч','Сантехникч','Үйлчлэгч','Жижүүр','Бусад']
                        // },
                        series: [
                            {
                                name: 'Албан тушаалын төрлөөр',
                                type: 'pie',
                                radius: '50%',
                                center: ['50%', '45%'],
                                data: this.albantushaal.map(row=>{
                                    return {
                                        value:row.too,
                                        name:row.torloor
                                    }
                                }),
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    }
                } else {
                    return null
                }

            },

        },
        data () {
            return {
                "albantushaal": [],
                "bagsherhzereg": [],
                "meregjilss":[],
                "undsenbagsh":[],
            }
        },
        mounted () {
            this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                getBagshlahErhiinZereg().then(response=>{

                    this.undsenbagsh = response.data.undsenbagsh;
                    this.meregjilss = response.data.meregjilss;
                    this.albantushaal = response.data.albantushaal;
                    this.bagsherhzereg = response.data.bagsherhzereg;
                    // console.log(response.data);
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
        },
    }
</script>
